<template>
  <div style="padding-bottom: 28px;width: 100%;">
    <!-- <div style="padding-bottom: 28px;margin: 0 -14px;"> -->
    <!-- <template>
      <div class="courses">
        <div @click="goToDetail(item)" class="course_item" v-for="item in data.records" :key="item.id">
          <img :src="item.url" alt="" />
          <div class="item_info">
            <h3 class="title text-cut">{{ item.planClassesName }}</h3>
            <span class="tag">{{ typeList[item.type] }}</span>
            <span>{{ item.studyNum }}人已学</span>
            <a-button class="apply" type="primary" @click.stop="goToDetail(item)">立即报名</a-button>
          </div>
        </div>
      </div>
      <a-pagination v-model="current" :total="data.total" show-less-items />
    </template> -->
    <z-pagination :spinning="spinning" :size="8" :total="data.total" @loadData="loadData">
      <div class="courses">
        <div @click="goToDetail(item)" class="course_item" v-for="item in data.records" :key="item.id">
          <img :src="item.url" alt="" />
          <div class="item_info">
            <h3 class="title text-cut">{{ item.planClassesName }}</h3>
            <span class="tag">公开课</span>
            <span>{{ item.studyNum }}人已学</span>
            <a-button class="apply" type="primary" @click.stop="goToDetail(item)">立即报名</a-button>
          </div>
        </div>
      </div>
    </z-pagination>
  </div>
</template>
<script>
import zPagination from '@/components/ZPagination'
import Vue from 'vue'
export default {
  name: '',
  props: {
    spinning: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {
          records: [],
          total: 0
        }
      }
    }
  },
  data() {
    return {
      current: 1,
      typeList: {
        0: '公开课',
        1: '系统班'
      },
    }
  },
  components: {
    zPagination
  },
  methods: {
    loadData(v) {
      this.$emit('current-change', v)
    },
    goToDetail(item) {
      this.$router.push({ name: 'myClassDetail',
       query: {
        noCourse: true,
         classesId: item.id,
        ocode: Vue.ls.get('code')
      }
    })
    }
  },
  watch: {
    current(v) {
      this.$emit('current-change', v)
    }
  }
}
</script>
<style lang="less" scoped>
.courses {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 8px;
  .course_item {
    display: flex;
    flex: 50%;
    max-width: 49%;
    height: 163px;
    // margin: 0 12px;
    margin-bottom: 12px;
    background: #ffffff;
    border-radius: 5px;
    // box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);
    box-shadow: 0px 2px 16px 0px rgba(0,0,0, .07);
    .item_info {
      flex: 1;
      padding: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      color: #5e668d;
      max-width: 50%;
      .title {
        font-size: 14px;
        color: #181d21;
        width: 100%;
      }
      .tag {
        width: max-content;
        padding: 3px;
        // margin: 8px 0;
        color: #fff;
        background: #00cbde;
        border-radius: 3px;
      }
      .apply {
        height: 27px;
        background: #1564ff;
        border-radius: 14px;
        align-self: end;
        margin-top: 16px;
      }
      span {
        font-size: 12px;
        line-height: 12px;
      }
    }
    img {
      width: 195px;
      height: 147px;
      margin-left: 9px;
      object-fit: cover;
      align-self: center;
      border-radius: 5px;
    }
  }
}
.ant-pagination {
  text-align: center;
}
</style>
